module.exports = __webpack_public_path__ + "media/images/icon_list/message-a622af9c769afd327816db5ce4e45bfd.svg";